var map = {
	"./backward walking turn.fbx": "a4b2",
	"./drunk idle variation (2).fbx": "8fa0",
	"./drunk idle variation.fbx": "9b87",
	"./drunk idle.fbx": "39b6",
	"./drunk run backward.fbx": "b9e6",
	"./drunk run forward.fbx": "05d2",
	"./drunk running left turn.fbx": "809a",
	"./drunk turn.fbx": "4da0",
	"./drunk walk backwards.fbx": "1453",
	"./drunk walk.fbx": "baf4",
	"./drunk walking turn.fbx": "0b17",
	"./run backward arc right.fbx": "2bbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4835";